import React, { useEffect, useState } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

const Toast = ({ t, timeOut, message }) => {
  const [status, setStatus] = useState('out');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (message) {
      setStatus('in');
      setOpen(true);

      setTimeout(() => {
        setStatus('out');

        // Wait until the animation play out before hiding
        setTimeout(() => {
          setOpen(false);
        }, 500);
      }, timeOut);
    }
    // the toast only (re)starts when a new message arrives, not when the timeout prop changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  return (
    <div className={`toast-container ${status}`}>
      {open && (
        <span className="toast-message">
          {t(message)}
          <span className="toast-close" onClick={() => setOpen(false)}>
            &times;
          </span>
        </span>
      )}
    </div>
  );
};

const mapStateToProps = ({ common }) => ({
  timeOut: common.toastTimeOut,
  message: common.toastMessage,
});

export default connect(mapStateToProps)(translate('common')(Toast));
